export const OK = 200;

export const MULTIPLE_CHOICES = 300;

export const UNAUTHORIZED = 401;
